import axios from "axios";

// Obtener URL base desde variables de entorno de Vite
const BASE_URL = import.meta.env.VITE_API_URL || "https://restaurante.altivaweb.com/BACK/public" /*import.meta.env.VITE_API_URL || "http://localhost:8085";*/

// Crear instancia de Axios con la URL base de tu backend
const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Variable para evitar múltiples renovaciones simultáneas
let isRefreshing = false;

// Interceptor de request — agrega token, punto de venta, y renueva si está por expirar
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    const puntoVentaId = localStorage.getItem("punto_venta_id");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (puntoVentaId) {
      config.headers["X-Punto-Venta"] = puntoVentaId;
    }

    // Verificar si el token está por expirar (menos de 30 minutos)
    const expiresAt = localStorage.getItem("token_expires_at");
    if (expiresAt && token && !isRefreshing) {
      const expiry = new Date(expiresAt);
      const minutesLeft = (expiry - new Date()) / 1000 / 60;

      if (minutesLeft < 30 && minutesLeft > 0) {
        isRefreshing = true;
        try {
          const res = await axios.post(
            `${BASE_URL}/api/refresh-token`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("token_expires_at", res.data.expires_at);
          config.headers.Authorization = `Bearer ${res.data.token}`;
        } catch (e) {
          console.error("Error renovando token:", e);
        } finally {
          isRefreshing = false;
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta — si el token expiró redirige al login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expires_at");
      localStorage.removeItem("company");
      localStorage.removeItem("punto_venta_id");
      window.location.href = "/";
    }
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;